import GUI from 'lil-gui';
// const gui = new GUI();
let settings = {
  debug: false,
  style: 1
}
// gui.add( settings, 'debug' );
// gui.add( settings, 'style',[1,2,3,4,5,6,7,8,9,10,11,12]);
let sets = [...document.querySelectorAll(".symbolssvgs")];
let allTheClocks = sets.map((item, i) => {
  let color = item.getAttribute("data-color");
  let numberUrls = [...item.querySelectorAll("img")];
  numberUrls = numberUrls.map((item) => {
    return item.src;
  });
  return {
    color: color,
    hour: i,
    numberUrls,
  };
});
let colons = [...document.querySelectorAll(".clock__colonpath")];

let symbols = [
  ...document.querySelector(".symbolssvgs").querySelectorAll("img"),
];
let symbolURLS = symbols.map((item) => {
  return item.src;
});

let hour1 = document.querySelector("[data-hour1]");
let hour2 = document.querySelector("[data-hour2]");

let minute1 = document.querySelector("[data-minute1]");
let minute2 = document.querySelector("[data-minute2]");

let second1 = document.querySelector("[data-second1]");
let second2 = document.querySelector("[data-second2]");

const clock = [hour1, hour2, minute1, minute2, second1, second2];
let currentSet = -1;
let currentChars;
let lastsecond = -1;


function raf(){

  const currentTime = new Date();
  let h = (currentTime.getHours() - 1 + 24)%12 ;
  if(settings.debug){
    h = settings.style-1
  }

  


  let showhour = currentTime.getHours()%12;
  if(showhour==0) showhour = 12;
  const hour = String(showhour).padStart(2, 0);
  const minute = String(currentTime.getMinutes()).padStart(2, 0);
  const second = String(currentTime.getSeconds()).padStart(2, 0);



  let currentString = hour + minute + second;
  let currentArray = currentString.split("");


  if(lastsecond != currentTime.getSeconds()){
    if (currentSet != h) {
      currentSet = h;
      
      colons.forEach((c) => c.setAttribute("fill", allTheClocks[currentSet].color));
      currentChars = allTheClocks[currentSet].numberUrls;
    }

    // debug
    
    // currentChars = allTheClocks[9].numberUrls;
    // currentArray = '100031'.split('');

    lastsecond = currentTime.getSeconds();
    currentArray.forEach((item, index) => {
      clock[index].querySelector("img").src = currentChars[item];
    });
  }
  


  

  window.requestAnimationFrame(raf);
}

raf()
